/**
 * CME MES candle overlay on the MNQ/NQ price chart (issue #620): on / off.
 * Off by default; the small toggle on the price pane flips it and the choice
 * is kept per device (localStorage `mes-candle-overlay`). Drawing and the
 * rolling ratio live in utils/mesCandles.ts (+ mesCandleFeedStore) and ChartView.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MesCandleOverlayState {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
  toggle: () => void;
}

/** Only an explicit `true` turns it on (missing / corrupt blobs stay off). */
export function mergeMesCandleOverlay(persisted: unknown): Pick<MesCandleOverlayState, 'enabled'> {
  const p = (persisted && typeof persisted === 'object' ? persisted : {}) as Record<string, unknown>;
  return { enabled: p.enabled === true };
}

export const useMesCandleOverlayStore = create<MesCandleOverlayState>()(
  persist(
    (set, get) => ({
      enabled: false,
      setEnabled: (v) => set({ enabled: v === true }),
      toggle: () => set({ enabled: !get().enabled }),
    }),
    {
      name: 'mes-candle-overlay',
      partialize: (s) => ({ enabled: s.enabled }),
      merge: (persisted, current) => ({ ...current, ...mergeMesCandleOverlay(persisted) }),
    },
  ),
);
